import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function HashtagsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Hashtags />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Hashtags />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Hashtags />
            </Route>
            <Route path={ `${ path }/:slug` } >
                { ({ match, history }) => <Pages.Hashtag match={ match } history={ history } exact /> }
            </Route>
        </Switch>
    );
}

